export default {
  quizResults: [],
  result: null,
};
